import { c as _c } from "react/compiler-runtime";
import type { ComparisonTableColumn } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { SectionTitle } from '@cc-shopping/ui/composites/SectionTitle';
import Grid from '@mui/material/Grid';
import Column from 'src/app/credit-cards/reviews/components/Body/ComparisonTable/ComparisonTable';
import ComparisonTableContextProvider, { MAXIMUM_COLUMNS_DESKTOP, MAXIMUM_COLUMNS_MOBILE } from 'src/app/credit-cards/reviews/components/Body/ComparisonTable/Context';
import { tableOfContentsMap } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/constants';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { type ExperimentOfferData, ExperimentOfferProvider } from 'src/shared/providers/ExperimentOfferContext';
export default function ReviewComparisonTable() {
  const $ = _c(2);
  const {
    comparisonTable
  } = useReviewContext();
  let t0;
  if ($[0] !== comparisonTable) {
    t0 = <ComparisonTableContextProvider comparisonTable={comparisonTable}>{_temp2}</ComparisonTableContextProvider>;
    $[0] = comparisonTable;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp2(t0) {
  const {
    columns,
    driversIds
  } = t0;
  return <Grid id={tableOfContentsMap.COMPARE_TO_OTHER_CARDS.id} size={12}><FeatureViewed entityName="accordion" entitySection="Compare to Other Cards" impressionPosition={3}><div><SectionTitle icon={{
          iconNode: <span aria-hidden="true" data-testid="section-title-icon" className="mask-icon mask-icon-list-alt" style={{
            width: "2rem",
            height: "2rem",
            backgroundColor: "#008254",
            transform: "rotate(90deg)"
          }} />
        }} heading={{
          text: "Compare to Other Cards"
        }} /><Grid container={true} sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: `repeat(${Math.min(MAXIMUM_COLUMNS_MOBILE, columns.length)}, minmax(0, 1fr))`,
            md: `repeat(${Math.min(MAXIMUM_COLUMNS_DESKTOP, columns.length)}, minmax(0, 1fr))`
          },
          gridTemplateRows: `repeat(${driversIds.length + 2}, auto)`,
          gridAutoFlow: "column"
        }}>{columns.map(_temp)}</Grid></div></FeatureViewed></Grid>;
}
function _temp(column, columnIndex) {
  const {
    marketplaceEntity: t0
  } = column;
  const {
    analytics: t1,
    details: t2,
    id,
    displayName,
    institution,
    product
  } = t0;
  const {
    monetizable,
    sectionName,
    offerId
  } = t1;
  const {
    isMonetizing,
    directApplyLink
  } = t2;
  const experimentOfferData = {
    offerId: id,
    isMonetizing,
    directApplyLink,
    institution,
    product
  };
  return <ExperimentOfferProvider key={id} value={experimentOfferData}><AnalyticsSkuViewed id={id} impressionSection={sectionName} impressionPosition={columnIndex} institutionId={institution.id} institutionName={institution.name} name={displayName} monetizable={monetizable} offerId={offerId} offerName={displayName} productId={product.id} productName={product.name}><Column column={column} columnIndex={columnIndex} /></AnalyticsSkuViewed></ExperimentOfferProvider>;
}